import { render } from "./Results1.vue?vue&type=template&id=8e1b0f28&scoped=true"
import script from "./Results1.vue?vue&type=script&lang=js"
export * from "./Results1.vue?vue&type=script&lang=js"

import "./Results1.vue?vue&type=style&index=0&id=8e1b0f28&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8e1b0f28"]])

export default __exports__